angular.module('nv.components.tooltip-open', []);
